<template>
    <div class="bottom-banner-box out-box">
        <div class="bottom-banner inner-box">
            <div class="logo-box">
                <img src="../assets/img/logo.png">
                <div class="phone clearfix">
                    <img src="../assets/img/phone2.png" style="width: 16px;height: 16px;" alt="">
                    <span>{{ phone.phone1 }}</span>
                </div>
                <div class="address">{{ address }}</div>
            </div>
            <div class="list">
                <div class="list-title">首页</div>
                <div class="list-item" @click="goIndex('introduction')">公司简介</div>
                <div class="list-item" @click="goIndex('core')">核心理念</div>
                <div class="list-item" @click="goIndex('product-display')">产品展示</div>
                <div class="list-item" @click="goIndex('experience')">产品体验</div>
                <div class="list-item" @click="goIndex('team-style')">团队风采</div>
                <div class="list-item" @click="goIndex('honor')">荣誉展示</div>
            </div>
            <div class="list">
                <div class="list-title">关于我们</div>
                <div class="list-item" @click="goAbout('company')">公司简介</div>
                <div class="list-item" @click="goAbout('brand')">品牌介绍</div>
                <div class="list-item" @click="goAbout('develop')">发展历程</div>
                <div class="list-item" @click="goAbout('team')">团队风采</div>
                <div class="list-item" @click="goAbout('honor2')">荣誉展示</div>
            </div>
            <div class="list">
                <div class="list-title">业务板块</div>
                <div class="list-item" @click="goApplicate('join')">招商加盟</div>
                <div class="list-item" @click="goApplicate('system')">加盟商全周期赋能体系</div>
                <div class="list-item" @click="goApplicate('experience')">哆念捻三大品牌产品精准赋能学习</div>
            </div>
            <div class="list">
                <div class="list-title">产品中心</div>
                <div class="list-item" @click="goProduct('product-display')">哆念书房</div>
                <div class="list-item" @click="goProduct('product-display')">词诀王智能记忆系统</div>
                <div class="list-item" @click="goProduct('product-display')">哆念捻AI双语学习机</div>
            </div>
            <div class="list">
                <div class="list-title">解决方案</div>
                <div class="list-item" @click="goSolve('training')">在线培训</div>
                <div class="list-item" @click="goSolve('organization')">组织架构</div>
            </div>
            <div class="list">
                <div class="list-title">新闻资讯</div>
                <div class="list-item" @click="goNews('updates')">公司最新动态</div>
                <div class="list-item" @click="goNews('industry')">行内资讯</div>
            </div>
            <div class="list">
                <div class="list-title">精彩案例</div>
                <div class="list-item" @click="goCase('center')">部分体验中心店</div>
                <div class="list-item" @click="goCase('moment')">部分合作瞬间</div>
            </div>
            <div class="list">
                <div class="list-title">加入我们</div>
                <div class="list-item" @click="goJoin('talents')">招贤纳士</div>
                <div class="list-item" @click="goJoin('contact')">联系我们</div>
            </div>
            <div class="code">
                <img v-if="ewm.data" :src="ewm.data" style="width: 100%;" alt="">
                <div class="code-desc">{{ ewm.data2 }}</div>
            </div>
        </div>
        <div class="line4"></div>
        <div class="ba">
            <span class="footer">{{ footerMsg }}</span>
            <a href="https://beian.miit.gov.cn" target="_blank" class="footer">{{ beian }}</a>
        </div>
    </div>
</template>
<script>
import { getPhone, getAddress, getBeian, getEwm, getFooterMsg } from '../api/index';
export default {
    components: {
    },
    data() {
        return {
            phone: '',
            beian: '',
            address: '',
            ewm: '',
            footerMsg: ''
        }
    },
    created() {
        this.getphone()
        this.getaddress()
        this.getbeian()
        this.getewm()
        this.getMsg()
    },
    mounted() {
        // console.log(this.ewm);
    },
    methods: {
        getMsg() {
            getFooterMsg().then(res => {
                if (res.code == 0) {
                    this.footerMsg = res.data
                }
            })
        },
        goIndex(id) {
            this.$router.push({
                path: `/#${id}`
            });
        },
        goAbout(id) {
            this.$router.push({
                path: `/about/#${id}`
            });
        },
        goApplicate(id) { 
            this.$router.push({
                path: `/applicate/#${id}`
            });
        },
        goProduct(id) {
            this.$router.push({
                path: `/product/#${id}`
            });
        },
        goSolve(id){
            this.$router.push({
                path: `/solve/#${id}`
            });
        },
        goNews(id) {
            this.$router.push({
                path: `/news/#${id}`
            });
        },
        goCase(id) {
            this.$router.push({
                path: `/case/#${id}`
            });
        },
        goJoin(id) {
            this.$router.push({
                path: `/join/#${id}`
            });
        },
        getphone() {
            getPhone().then(res => {
                if (res.code == 0) {
                    this.phone = res.data
                }
            })
        },
        getbeian() {
            getBeian().then(res => {
                if (res.code == 0) {
                    this.beian = res.data
                }
            })
        },
        getaddress() {
            getAddress().then(res => {
                if (res.code == 0) {
                    this.address = res.data
                }
            })
        },
        getewm() {
            getEwm().then(res => {
                if (res.code == 0) {
                    this.ewm = res.data
                }
            })
        }
    }
}
</script>
<style scoped>
.bottom-banner-box {
    background-color: #1D1E1F;
}

.bottom-banner {
    display: flex;
    padding-top: 68px;
    box-sizing: border-box;
    background-color: #1D1E1F;
    justify-content: space-between;
}

.logo-box{
    width: 15%;
}
.logo-box>img{ 
    width: 70%;
}

.phone {
    margin-top: 34px;
}

.phone>span {
    margin-left: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px;
}

.address {
    margin: 16px 0 0 24px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
}

.list-title {
    text-align: center;
    margin-bottom: 14px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
}

.list-item {
    text-align: center;
    padding: 6px 0;
    font-weight: 400;
    font-size: 14px;
    color: #8F9499;
    line-height: 20px;
    cursor: pointer;
}

.code {
    width: 7%;
}

.code-desc {
    font-weight: 400;
    font-size: 13px;
    color: #8F9499;
    line-height: 18px;
    margin-top: 8px;
    text-align: center;
}

.line4 {
    margin-top: 40px;
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
}
.ba{
    text-align: center;
    padding: 30px 0;
}

.footer {
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
    color: #8F9499;
    line-height: 20px;
    text-align: center;
}
@media screen and (max-width: 768px){
    .list{
        display: none;
    }
    .logo-box{
        width: 100%;
    }
    .code{
       display: none;
    }
    .logo-box>img{ 
        width: 30%;
    }
    .bottom-banner{
        padding-top: 20px;
    }
    .line4{
        margin: 10px 0;
    }
    .ba{
        padding: 10px 0;
    }
    .phone{
        margin-top: 10px;
    }
}
</style>